import { render, staticRenderFns } from "./ClinicalTransaction.vue?vue&type=template&id=6e82a39b"
import script from "./ClinicalTransaction.vue?vue&type=script&lang=ts"
export * from "./ClinicalTransaction.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/components/recipients/_locales/ClinicalTransaction.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2Frecipients%2FClinicalTransaction.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports